"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledNumberRating = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _NumberRatingMixin = require("../../mixins/components/NumberRatingMixin");
var StyledNumberRating = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledNumberRating",
  componentId: "c11n-8-107-0__sc-ilk12m-0"
})(["", ""], _NumberRatingMixin.NumberRatingMixin);
exports.StyledNumberRating = StyledNumberRating;